import { apiService } from 'services/ServiceRegistry';
import navigation from 'services/NavigationService';
import type { LicenseType } from '../LicenseRequestForm';

/**
 * Our FormHooksModule for Asset Request Form
 * Here we create our logic for submit and parsing form data
 */
const FormHooksModule = () => {
  const getPONumber = (form: Object) => {
    const {
      poNumber: { chooseExistingOrNew, number },
    } = form.values();

    if (chooseExistingOrNew === 'use_existing') {
      return '';
    }

    if (chooseExistingOrNew === 'use_new') {
      return number;
    }
  };

  const getFormData = (form: Object) => {
    const accountId = form.$('chooseAccount.tradingAccount').extra.selectID;
    const licenseTypeId = form.$('chooseLicense.type').extra.selectID;
    const manufacturerId = form.$('licenseDetails.manufacturer').extra.selectID;
    const productId = form.$('licenseDetails.product').extra.selectID;
    const {
      requiredDate,
      customerDetails,
      assetDetails,
      newAssetDetails,
      comments: { comment },
    } = form.values();
    const type: LicenseType = form.values().chooseLicense.type;
    const poNumber = getPONumber(form);

    const request = {
      account_id: accountId,
      license_request_type_id: licenseTypeId,
      manufacturer_id: manufacturerId,
      product_id: productId,
      date_required: requiredDate.date,
      new_asset_number: newAssetDetails.assetNumber,
      new_serial_number: newAssetDetails.serialNumber,
      requested_by: customerDetails.id,
      po_number: poNumber,
      comments: comment,
    };

    if (type === 'Transfer Existing License' || type === 'Remove Current License') {
      request.current_asset_number = assetDetails.assetNumber;
      request.current_serial_number = assetDetails.serialNumber;
    }

    if (type === 'Remove Current License') {
      request.current_key_code = assetDetails.returnKeyCode;
    }

    return request;
  };

  const submitForm = (formData: Object, localState: Object, t: Function) => {
    apiService
      .createResource('license-requests', formData)
      .then((response: Object) => {
        localState.isLoading = false;
        localState.responseMessage = t('general:messages.save_success');
        setTimeout(() => {
          localState.showResponseMessage = false;
          /*eslint-disable max-nested-callbacks*/
          setTimeout(() => {
            // Snackbar animation 225ms
            navigation.navigateTo(`/sent-requests/${response.sentRequestId}`);
          }, 225);
        }, 1200);
      })
      .catch((err: string) => {
        localState.isLoading = false;
        localState.responseMessage =
          err && err.errors && err.errors.name && err.errors.name.length > 0
            ? err.errors.name[0]
            : err && err.message;
        localState.hasSuccess = false;
        localState.hasError = true;
      });
  };

  return {
    onSuccess(localState: Object, t: Function) {
      return form => {
        localState.isLoading = true;
        localState.responseMessage = t('general:messages.saving_form');
        localState.showResponseMessage = true;
        localState.hasError = false;
        localState.hasSuccess = true;

        const data = getFormData(form);

        submitForm(data, localState, t);
      };
    },

    onError(localState: Object, t: Function) {
      return () => {
        localState.isLoading = false;
        localState.responseMessage = t('general:messages.form_error');
        localState.showResponseMessage = true;
        localState.hasSuccess = false;
        localState.hasError = true;
      };
    },
  };
};

export const onSuccess = FormHooksModule().onSuccess;
export const onError = FormHooksModule().onError;
